<script>

import {asyncAngularInvoke} from '/vodalys/vvuejs'

export default {
  components: {  },
  props: ['component', 'handler'],
  computed: {},
  methods: {
    displayPopup: function () {
        let _zis = this
        asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
            v17Modal.ok($rootScope, $rootElement.find('body'), {
                'title' : 'New GCU',
                'rawhtml' : true,
                'content': `<div style="max-width:500px">Dear customer,<br><br>
                    Please agree to the new <a href="https://www.vodalys.io/en/general-terms-of-service/" target="_blank">General Condition of Use</a> in order to continue to use the Vodalys platform.
                    `,
                disableOuterClick: true,
                okLabel: 'I AGREE TO THE NEW GCU',
                ok : function()
                {
                    return _zis.handler.action(_zis.component, 'gotit', [])
                }
            })
        })
    },
  },
  mounted : function ()
  {
      if (this.component.already_gotit)
      {
          console.log('already gotit!')
      }
      else
      {         
        setTimeout(()  => {
            this.displayPopup()
        }, 5000)
      }
  }
};


</script>

<template>
</template>
<style lang="scss" scoped>
</style>